// МИНИАТЮРА ОБЛОЖКИ ШАГА 7 — реальный §I паспорта во фрейме (пин `s472.d2`). B9-3.
//
// ⭐ НЕ КОПИЯ РЕНДЕРЕРА. Разметка — `renderSectionHtml({ id: 'I' })` из `src/render/assemble.jsx`, того
// же места, что собирает документ: артборд `Artboard` + `SectionI` на `viewI(passport)`. Своей серией
// (`s472.d2`): паспорт строится на маунте шага 7 из конверта, а не берётся у шага 5.
//
// ⭐ ПОЧЕМУ IFRAME. `SectionI` живёт на `r10.css`, а у того свой `:root` с токенами паспорта: подключи
// его на маршрут визарда — и он перекрасил бы оболочку и экраны (то же, о чём шапка
// `wizard-tokens.css`). Фрейм держит паспортный css внутри себя; снаружи — коробка 84×84.
//
// ⛔ PRIVACY GUARD (§5, §11 спеки s9): в превью — только §I. Функция не принимает номер раздела и
// другого не рендерит; гард — `StepSeven.test.jsx`.

import { renderSectionHtml } from '../../render/assemble.jsx';
import { localIsoDate } from '../../render/docDate.js';
import r10 from '../../styles/r10.css?raw';

/** Ширина артборда документа (`--page-w` в `r10.css`). */
export const PAGE_W = 1240;
/** Сторона миниатюры фронт-листа (`.stack .thumb` 84×84, `s7-v4-objects.css:13`). */
export const THUMB = 84;

/** Шрифты документа — та же строка, что в `index.html`: фрейм своего `<head>` не наследует. */
export const FONTS = 'https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;1,6..72,400;1,6..72,500&family=Geist:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;700&display=swap';

/** Разметка §I для фрейма — только §I (privacy guard). */
// Дата обложки — сегодняшняя (дата генерации, `docDate.js`): бейдж «first reading» и «recorded».
export const coverMarkup = (passport, generatedAt = localIsoDate()) =>
  renderSectionHtml({ id: 'I', roman: 'I' }, passport, { generatedAt });

/**
 * Документ фрейма: §I во всю ширину артборда, ужатый до `size` по ширине и обрезанный по верху
 * квадрата. ⚠️ Квадрат режет низ листа: обложка 1240×1754, миниатюра — её верх (ран, бровь, титул,
 * начало чарта). Борд рисует фронт-лист условно (полосы вместо текста, `readThumb`), пропорций у
 * него нет — это решение порта, названо в сдаче.
 */
/** Высота артборда документа (`--page-h` в `r10.css`): обложка раскрытия — лист целиком. */
export const PAGE_H = 1754;

/**
 * ДОКУМЕНТ РАСКРЫТОЙ ОБЛОЖКИ (cover preview, §5 спеки s9; B9-4): одна страница §I во всю ширину,
 * без скролла и листания. Ширина плиты экрана заранее не известна (вьюпорт человека), поэтому
 * масштаб считает фрейм сам на загрузке и ресайзе — `innerWidth / 1240`; высоту держит
 * `aspect-ratio` плиты снаружи (`wizard-s7.css`, `.s7-cover-plate`), лист не обрезается.
 *
 * ⛔ Privacy guard тот же, что у миниатюры: разметка — только `coverMarkup` (§I). Ни номера
 * раздела на входе, ни второго вызова рендерера.
 */
export function coverPageDoc(passport) {
  return '<!doctype html><html><head><meta charset="utf-8">'
    + `<link rel="stylesheet" href="${FONTS}">`
    + `<style>${r10}</style>`
    + '<style>html,body{margin:0;overflow:hidden;background:#0a0b0d}'
    + `.s7-cv{width:${PAGE_W}px;transform-origin:0 0}</style>`
    + `</head><body><div class="s7-cv">${coverMarkup(passport)}</div>`
    + `${fitScript('.s7-cv')}</body></html>`;
}

/**
 * FIT-JS ЛИСТА A4 — ОДИН НА ОБЛОЖКУ И ДОКУМЕНТ OPEN (B9-6, `s965.d1`: общую часть вынести, не копировать).
 * Масштаб — ширина окна / 1240, `transform-origin 0 0`, пересчёт на `resize`. `stack` — для стопки
 * артбордов: `scale` не меняет поток, поэтому высота обёртки ставится руками = высота × масштаб, иначе
 * под документом остаётся хвост прокрутки в полную высоту стопки. Обложка (`stack: false`) — байт
 * прежнего скрипта `coverPageDoc`.
 */
export function fitScript(sel, { stack = false } = {}) {
  const body = stack
    ? `var k=window.innerWidth/${PAGE_W};c.style.transform='scale('+k+')';c.parentNode.style.height=Math.ceil(c.offsetHeight*k)+'px'`
    : `c.style.transform='scale('+(window.innerWidth/${PAGE_W})+')'`;
  return `<script>(function(){var c=document.querySelector('${sel}');function fit(){${body}}fit();window.addEventListener('resize',fit)})()</`
    + 'script>';
}

export function coverDoc(passport, size = THUMB) {
  const k = size / PAGE_W;
  return '<!doctype html><html><head><meta charset="utf-8">'
    + `<link rel="stylesheet" href="${FONTS}">`
    + `<style>${r10}</style>`
    + `<style>html,body{margin:0;width:${size}px;height:${size}px;overflow:hidden;background:#0a0b0d}`
    + `.s7-cv{width:${PAGE_W}px;transform:scale(${k});transform-origin:0 0}</style>`
    + `</head><body><div class="s7-cv">${coverMarkup(passport)}</div></body></html>`;
}
